<template>
  <v-dialog width="350px" persistent v-model="editDialog" class="">
    <div class="pa-0 pl-2" slot="activator">
      <v-icon class="text-xs-right">edit</v-icon>
    </div>
    <v-card>
      <v-container>
        <v-layout justify-end row wrap>
          <v-flex xs1 class="mb-2">
            <v-icon depressed class="cyan--text text--lighten-1" @click="editDialog = false">close</v-icon>
          </v-flex>
          <v-flex xs12 class="mb-2">
            <v-card-title class="text-xs-center justify-center"><h2>Edit {{ trial.trialName }}</h2></v-card-title>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card-text>
              <v-text-field
                name="title"
                label="Title"
                id="title"
                v-model="editedTitle"
                required>
              </v-text-field>
              <v-text-field
              name="trial.editedDescription"
              label="Edit Trial Description"
              id="editedDescription"
              multi-line
              required
              v-model="editedDescription"
            ></v-text-field>
            <v-select
                name="trial.editedEnrollment"
                label="Edit Trial Status"
                :items="enrollments"
                item-value="enrollmentId"
                item-text="enrollmentName"
                v-model="editedEnrollment"
                id="editedEnrollment"
                max-height="400"
                hint="Pick your enrollment"
                persistent-hint
              ></v-select>
            <v-text-field
                name="trialLink"
                label="Edit Trial Link"
                id="trialLinks"
                v-model="editedLink"
                required>
              </v-text-field>
            </v-card-text>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card-actions class="justify-center">
              <v-btn depressed class="grey lighten-1 white--text" @click="editDialog = false">Cancel</v-btn>
              <v-btn depressed class="white--text cyan " @click="onSaveChanges">Save</v-btn>
            </v-card-actions>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['trial'],
  data () {
    return {
      trialEnrollment: '',
      editDialog: false,
      editedTitle: this.trial.trialName,
      editedEnrollment: this.trial.trialEnrollment,
      editedDescription: this.trial.trialDescription,
      editedLink: this.trial.trialLink
    }
  },
  computed: {
    enrollments () {
      return this.$store.getters.loadedEnrollments
    },
    loadEnrollments () {
      return this.$store.getters.loadedTrials
    }
  },
  methods: {
    onSaveChanges () {
      if (this.editedTitle.trim() === '' || this.editedDescription.trim() === '') {
        return
      }
      this.editDialog = false
      this.$store.dispatch('updateTrialData', {
        trialId: this.trial.trialId,
        trialName: this.editedTitle,
        description: this.editedDescription,
        trialEnrollment: this.editedEnrollment,
        trialLink: this.editedLink
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// EditTrialDetailsDialog.vue?f6df1aea